import HTTP from "../../http";
import { generateFilterValueQueryString } from "../../../utils";

const PRODUCTS_ENDPOINT = "/products";
const FILTER_ENDPOINT = "/filter";
const FILTER_VALUES_ENDPOINT = "/values";

export async function applyFilter(filter) {
  return await HTTP.post(PRODUCTS_ENDPOINT + FILTER_ENDPOINT, filter, {
    headers: { "Content-Type": "application/json" }
  });
}

export async function getPossibleFilterValues(key, query) {
  return await HTTP.get(
    PRODUCTS_ENDPOINT +
      FILTER_VALUES_ENDPOINT +
      generateFilterValueQueryString(key, query)
  );
}
